import script from "./TalkToTheBookV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./TalkToTheBookV2.vue?vue&type=script&setup=true&lang=ts"

import "./TalkToTheBookV2.vue?vue&type=style&index=0&id=b3837e38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3837e38"]])

export default __exports__